var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 851,
    height: 738,
    viewBox: "0 0 851 738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pqr81xhc5a",
    x1: "50%",
    x2: "50%",
    y1: "100.004%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xc1o2o970b",
    x1: "36.974%",
    x2: "64.111%",
    y1: "102.99%",
    y2: "4.113%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8btsqqemrc",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "url(#pqr81xhc5a)",
    opacity: 0.8,
    transform: "translate(310 15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.5,
    cy: 88.741,
    rx: 114.079,
    ry: 88.081
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426,
    cy: 104.5,
    fill: "#6369D1",
    rx: 112,
    ry: 86.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M332.667 113.613c0-47.915 49.7-86.76 111.013-86.76 19.036-.105 37.882 3.82 55.32 11.52C479.488 25.078 453.96 17 426.02 17 364.708 17 315 55.844 315 103.76c0 32.173 22.412 60.256 55.708 75.24-23.311-15.907-38.04-39.298-38.04-65.387z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M628 418.93L850.5 738 425.5 738 0.5 738 223 418.93 425.5 139z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518.5,
    cy: 381.5,
    r: 7.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.5,
    cy: 369.5,
    r: 3.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365 29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#xc1o2o970b)",
    d: "M100.274 92.579l9.609-28.414c6.784-20.315-.556-42.66-18.08-55.048l.078-.047c-3.78-2.651-7.925-4.744-12.306-6.212l-.132-.047-.148-.047C75.042 1.331 70.609.5 66.125.295c-1.587-.081-3.176-.081-4.762 0-2.752.144-5.487.52-8.175 1.126-.78.17-1.559.365-2.268.575-.709.21-1.504.435-2.244.675-1.481.49-2.938 1.04-4.364 1.67-.717.31-1.427.637-2.12.986-2.097 1.032-4.116 2.215-6.04 3.541-.647.443-1.278.9-1.901 1.367-7.703 5.837-13.47 13.845-16.553 22.985L2.595 77.988C.218 85.008-.497 92.482.507 99.824c.155 1.126.35 2.244.576 3.354.226 1.11.507 2.206.78 3.293.21.722.428 1.444.67 2.159.358 1.064.78 2.127 1.177 3.168.288.691.592 1.382.911 2.066.632 1.358 1.333 2.686 2.089 3.983.756 1.297 1.558 2.563 2.462 3.79.655.916 1.349 1.817 2.066 2.686.966 1.165 1.98 2.291 3.055 3.363 4.654 4.676 10.225 8.348 16.365 10.786l.265.109c.33-.583.694-1.146 1.091-1.685 2.338-3.192 6.406-5.436 10.28-4.598.28.063.56.148.84.233 1.965.692 3.897 1.926 5.791 2.532 1.394.624 2.994.604 4.372-.054 3.787-2.012 2.385-8.356 5.634-11.136.152-.128.31-.247.476-.357-.046-.056-.088-.116-.125-.179 2.51-1.553 5.985-.52 8.876.482 3.118 1.095 7.186 1.832 9.352-.707 1.465-1.74 1.356-4.387 2.751-6.212 1.621-2.097 4.676-2.33 7.318-1.957h.132c5.066 2.081 10.599-1.375 10.21-6.818-.46-7.222 1.83-14.063 2.353-15.546z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.895 134.504c2.275-3.106 6.18-5.28 9.92-4.434 3.741.846 7.287 4.395 10.615 2.617 4.55-2.423 1.324-11.33 8.712-11.99 1.54-.101 3.081.165 4.497.777 3.117 1.265 7.996 2.694 10.396-.156 1.41-1.677 1.31-4.232 2.657-5.971 1.559-2.02 4.528-2.276 7.06-1.887l.126.039c4.886 2.01 10.232-1.328 9.85-6.578-.491-6.989 1.738-13.574 2.221-15.002l9.258-27.42c8.198-24.47-4.983-50.943-29.497-59.242-24.555-8.158-51.112 4.978-59.438 29.4L4.676 77.777c-7.875 23.543 4.02 49.124 27.135 58.358.33-.565.69-1.11 1.084-1.631z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.149,
    cy: 30.347,
    fill: "#000",
    opacity: 0.2,
    rx: 5.073,
    ry: 5.055
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.999,
    cy: 40.015,
    fill: "#000",
    opacity: 0.2,
    rx: 5.073,
    ry: 5.055
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M532.247 78c1.448 5.628 2.179 11.418 2.174 17.23 0 47.988-49.955 86.89-111.583 86.89-50.439-.03-93.054-26.08-106.838-61.826C326.239 160.058 371.324 190 425.41 190 487.036 190 537 151.098 537 103.11c-.016-8.594-1.628-17.11-4.753-25.11z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#8btsqqemrc)",
    opacity: 0.8,
    transform: "translate(193 82)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.5,
    cy: 60.252,
    rx: 230.861,
    ry: 60.042
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M425 84c-123.155 0-223 25.963-223 58h446c0-32.037-99.845-58-223-58zM425 200c123.155 0 223-25.966 223-58H202c0 32.034 99.845 58 223 58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M425 200c123.155 0 223-25.966 223-58H202c0 32.034 99.845 58 223 58z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 31,
    x: 318,
    y: 127,
    fill: "#000",
    opacity: 0.05,
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D8AF0",
    d: "M194.097 46.59c-1.405-.613-2.129-2.18-1.684-3.645.034-.11.056-.223.066-.337.043-.667-.358-1.283-.986-1.515-.628-.23-1.334-.022-1.734.513-.066.092-.121.192-.165.296-.61 1.407-2.18 2.131-3.648 1.683-.11-.034-.222-.056-.337-.066-.667-.043-1.284.358-1.516.985-.231.628-.022 1.333.514 1.733.09.07.19.128.296.172 1.405.613 2.129 2.18 1.684 3.646-.034.106-.056.216-.066.328-.047.669.353 1.289.982 1.522.629.234 1.337.025 1.738-.512.068-.094.123-.196.165-.304.625-1.39 2.191-2.096 3.648-1.642.11.034.222.056.337.066.667.043 1.284-.358 1.516-.985.231-.628.022-1.333-.514-1.733-.089-.081-.188-.15-.296-.205zM590.094 284.59c-1.394-.628-2.101-2.19-1.65-3.645.035-.11.057-.223.066-.337.044-.667-.359-1.283-.99-1.515-.63-.23-1.337-.022-1.74.513-.066.092-.121.192-.165.296-.612 1.407-2.188 2.131-3.661 1.683-.11-.034-.224-.056-.339-.066-.67-.043-1.289.358-1.521.985-.233.628-.023 1.333.515 1.733.091.07.191.128.297.172 1.394.628 2.101 2.19 1.65 3.646-.034.106-.056.216-.066.328-.048.669.353 1.289.985 1.522.631.234 1.342.025 1.745-.512.067-.094.123-.196.165-.304.627-1.39 2.2-2.096 3.661-1.642.11.034.224.056.339.066.67.043 1.289-.358 1.521-.985.233-.628.023-1.333-.515-1.733-.09-.081-.19-.15-.297-.205zM152.097 395.59c-1.405-.613-2.129-2.18-1.684-3.645.034-.11.056-.223.066-.337.043-.667-.358-1.283-.986-1.515-.628-.23-1.334-.022-1.734.513-.066.092-.121.192-.165.296-.61 1.407-2.18 2.131-3.648 1.683-.11-.034-.222-.056-.337-.066-.667-.043-1.284.358-1.516.985-.231.628-.022 1.333.514 1.733.09.07.19.128.296.172 1.405.613 2.129 2.18 1.684 3.646-.034.106-.056.216-.066.328-.047.669.353 1.289.982 1.522.629.234 1.337.025 1.738-.512.068-.094.123-.196.165-.304.625-1.39 2.191-2.096 3.648-1.642.11.034.222.056.337.066.667.043 1.284-.358 1.516-.985.231-.628.022-1.333-.514-1.733-.089-.081-.188-.15-.296-.205zM110.056 136.59c-1.389-.628-2.093-2.19-1.643-3.645.034-.11.056-.223.066-.337.043-.667-.358-1.283-.986-1.515-.628-.23-1.334-.022-1.734.513-.066.092-.121.192-.165.296-.61 1.407-2.18 2.131-3.648 1.683-.11-.034-.222-.056-.337-.066-.667-.043-1.284.358-1.516.985-.231.628-.022 1.333.514 1.733.09.07.19.128.296.172 1.405.613 2.129 2.18 1.684 3.646-.034.106-.056.216-.066.328-.047.669.353 1.289.982 1.522.629.234 1.337.025 1.738-.512.068-.094.123-.196.165-.304.625-1.39 2.191-2.096 3.648-1.642.11.034.222.056.337.066.667.043 1.284-.358 1.516-.985.231-.628.022-1.333-.514-1.733-.101-.085-.215-.154-.337-.205zM582.096 5.545c-1.365-.622-2.058-2.172-1.615-3.616.034-.109.055-.22.064-.334.043-.662-.352-1.273-.969-1.502-.617-.23-1.31-.023-1.705.508-.064.092-.118.19-.161.294-.615 1.38-2.155 2.079-3.587 1.629-.108-.034-.219-.056-.331-.066-.72-.152-1.442.25-1.698.944-.257.695.029 1.474.672 1.834.09.069.187.126.29.17 1.366.623 2.059 2.173 1.616 3.617-.033.105-.054.215-.064.325-.07.69.339 1.34.988 1.568.65.229 1.371-.022 1.742-.607.067-.093.12-.194.162-.301.614-1.38 2.154-2.079 3.587-1.629.107.033.218.055.33.065.657.043 1.264-.355 1.491-.977.228-.622.022-1.321-.505-1.718-.092-.082-.195-.151-.307-.204z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.353 0.661H7.647V13.883H5.353z",
    transform: "translate(170 202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 0.772L7.667 0.772 7.667 13.772 5.333 13.772z",
    transform: "translate(170 202) rotate(90 6.5 7.272)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.353 0.661H7.647V13.883H5.353z",
    transform: "translate(730 139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 0.772L7.667 0.772 7.667 13.772 5.333 13.772z",
    transform: "translate(730 139) rotate(90 6.5 7.272)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.353 0.661H7.647V13.883H5.353z",
    transform: "translate(651 357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 0.772L7.667 0.772 7.667 13.772 5.333 13.772z",
    transform: "translate(651 357) rotate(90 6.5 7.272)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 651,
    cy: 65,
    r: 5,
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 11,
    r: 5,
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 280,
    r: 5,
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272,
    cy: 121.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272,
    cy: 163.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 572,
    cy: 121.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 572,
    cy: 163.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425,
    cy: 97.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425,
    cy: 179.5,
    fill: "#6369D1",
    opacity: 0.15,
    rx: 27,
    ry: 5.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPage);
export default __webpack_public_path__ + "static/media/empty_page.7ef328cc2ee7b1580e28279c54c6b28e.svg";
export { ForwardRef as ReactComponent };